/* Selector rapido de talla  ·  DAR, 2-sep-2026
   Compartido por la rejilla de coleccion y el cross-sell del cajon.
   Vive enganchado al documento porque el cajon se repinta entero en cada
   cambio del carrito: si el enganche viviera en el cajon, se perderia.
   El alta la hace un <form action="/cart/add"> para que el cajon la
   intercepte como cualquier otra: un solo camino de alta. */
(function () {
    // Se engancha al documento entero: el mismo selector sirve en la rejilla
    // de coleccion y en el cross-sell del cajon, sin duplicar la logica.
    var raiz = document;
    if (document.documentElement.dataset.ccPickerListo) return;
    document.documentElement.dataset.ccPickerListo = '1';

    // Estado por tarjeta: que opcion lleva elegida
    function estado(tarjeta) {
      if (!tarjeta._cc) tarjeta._cc = { elegido: {} };
      return tarjeta._cc;
    }

    function datos(tarjeta) {
      var s = tarjeta.querySelector('[data-cc-variantes]');
      if (!s) return null;
      if (!tarjeta._ccDatos) {
        try { tarjeta._ccDatos = JSON.parse(s.textContent); } catch (e) { tarjeta._ccDatos = null; }
      }
      return tarjeta._ccDatos;
    }

    // Una variante calza si TODAS las opciones ya elegidas coinciden.
    // Las que aun no se eligen no filtran: por eso se puede empezar por
    // cualquiera de las tres, no solo por la primera.
    function calza(v, elegido, d, saltar) {
      for (var i = 0; i < d.opciones.length; i++) {
        var nombre = d.opciones[i].n;
        if (nombre === saltar) continue;
        if (elegido[nombre] && v.o[i] !== elegido[nombre]) return false;
      }
      return true;
    }

    function pintar(tarjeta) {
      var d = datos(tarjeta); if (!d) return;
      var e = estado(tarjeta);
      var cuerpo = tarjeta.querySelector('[data-cc-cuerpo]');
      cuerpo.innerHTML = '';

      // Una opcion con UN solo valor (tipico: "Estilo: Manga Corta") se elige
      // sola y no se pinta. Nadie abre un desplegable de una sola opcion, y
      // sin elegirla el boton se quedaba en "Elige una opcion": se veia muerto.
      d.opciones.forEach(function (op) {
        if (op.v.length === 1 && !e.elegido[op.n]) e.elegido[op.n] = op.v[0];
      });

      // En espacios angostos (el cross-sell del carrito) 20 chips no caben:
      // ahi va un desplegable por opcion. En la rejilla, donde hay ancho, los
      // chips siguen porque se ve de un golpe que talla NO hay.
      var compacto = tarjeta.querySelector('[data-cc-picker]').hasAttribute('data-cc-compacto');

      if (compacto) {
        d.opciones.forEach(function (op, idx) {
          if (op.v.length === 1) return;
          var grupo = document.createElement('label');
          grupo.className = 'cc-picker-grupo cc-select-grupo';

          // Sin etiqueta encima: el propio desplegable ya dice "Elegir talla",
          // y en el carrito cada renglon de mas es scroll.
          var sel = document.createElement('select');
          sel.className = 'cc-select';

          var vacia = document.createElement('option');
          vacia.value = '';
          vacia.textContent = 'Elegir ' + op.n.toLowerCase();
          sel.appendChild(vacia);

          op.v.forEach(function (valor) {
            var posible = d.variantes.some(function (v) {
              return v.o[idx] === valor && v.d && calza(v, e.elegido, d, op.n);
            });
            var o = document.createElement('option');
            o.value = valor;
            // La que no existe se queda en la lista pero apagada y marcada,
            // para que se entienda que existe pero no con lo ya elegido.
            o.textContent = posible ? valor : valor + ' — no disponible';
            o.disabled = !posible;
            if (e.elegido[op.n] === valor) o.selected = true;
            sel.appendChild(o);
          });

          sel.addEventListener('change', function () {
            if (sel.value) e.elegido[op.n] = sel.value;
            else delete e.elegido[op.n];
            pintar(tarjeta);
          });

          grupo.appendChild(sel);
          cuerpo.appendChild(grupo);
        });
      } else {
      d.opciones.forEach(function (op, idx) {
        if (op.v.length === 1) return;
        var grupo = document.createElement('div');
        grupo.className = 'cc-picker-grupo';
        var t = document.createElement('span');
        t.className = 'cc-picker-lbl';
        t.textContent = op.n;
        grupo.appendChild(t);

        var fila = document.createElement('div');
        fila.className = 'cc-picker-chips';

        op.v.forEach(function (valor) {
          // ¿existe ALGUNA variante disponible con este valor, dadas las demas
          // opciones ya elegidas? Si no, el chip se ve muerto en vez de dejar
          // que el cliente lo elija y falle al agregar.
          var posible = d.variantes.some(function (v) {
            return v.o[idx] === valor && v.d && calza(v, e.elegido, d, op.n);
          });

          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cc-chip' + (e.elegido[op.n] === valor ? ' is-elegido' : '') + (posible ? '' : ' is-muerto');
          b.textContent = valor;
          b.disabled = !posible;
          b.addEventListener('click', function () {
            if (e.elegido[op.n] === valor) delete e.elegido[op.n];
            else e.elegido[op.n] = valor;
            pintar(tarjeta);
          });
          fila.appendChild(b);
        });

        grupo.appendChild(fila);
        cuerpo.appendChild(grupo);
      });
      }

      // ¿ya hay una variante completa y disponible?
      var completo = d.opciones.every(function (o) { return e.elegido[o.n]; });
      var elegida = null;
      if (completo) {
        elegida = d.variantes.filter(function (v) { return v.d && calza(v, e.elegido, d, null); })[0];
      }

      var btn = tarjeta.querySelector('[data-cc-confirmar]');
      btn.disabled = !elegida;
      btn.textContent = elegida ? 'Añadir al carrito' : (completo ? 'Sin existencia' : 'Elige una opción');
      tarjeta.querySelector('[data-cc-id]').value = elegida ? elegida.id : '';
    }

    raiz.addEventListener('click', function (ev) {
      var abrir = ev.target.closest('[data-cc-abrir]');
      if (abrir) {
        var tarjeta = abrir.closest('[data-cc-tarjeta]') || abrir.closest('.cc-card');
        var p = tarjeta.querySelector('[data-cc-picker]');
        // El mismo boton abre y cierra: si ya esta abierto, un segundo toque
        // lo cierra en vez de no hacer nada.
        if (!p.hidden) { p.hidden = true; return; }
        document.querySelectorAll('[data-cc-picker]').forEach(function (o) { if (!tarjeta.contains(o)) o.hidden = true; });
        p.hidden = false;
        pintar(tarjeta);
        // Al desplegarse dentro del carrito, el selector nace medio fuera de
        // vista. Se acerca lo justo, sin saltos.
        if (p.scrollIntoView) {
          setTimeout(function () { p.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
        }
        return;
      }

      var cerrar = ev.target.closest('[data-cc-cerrar]');
      if (cerrar) { cerrar.closest('[data-cc-picker]').hidden = true; return; }

      var confirmar = ev.target.closest('[data-cc-confirmar]');
      if (confirmar) {
        var tarjeta2 = confirmar.closest('[data-cc-tarjeta]') || confirmar.closest('.cc-card');
        var form = tarjeta2.querySelector('[data-cc-form]');
        if (!form.querySelector('[data-cc-id]').value) return;
        // Se manda el formulario para que el cajon del carrito lo intercepte
        // como cualquier otro: un solo camino de alta, no dos.
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
        tarjeta2.querySelector('[data-cc-picker]').hidden = true;
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') document.querySelectorAll('[data-cc-picker]').forEach(function (p) { p.hidden = true; });
    });
  })();
